'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  opacity: ', ';\n  visibility: ', ';\n  pointer-events: none;\n  ', ';\n'], ['\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  opacity: ', ';\n  visibility: ', ';\n  pointer-events: none;\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _Button = require('../../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components


var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var visible = _ref.visible;
  return visible ? 1 : 0;
}, function (_ref2) {
  var visible = _ref2.visible;
  return visible ? 'visible' : 'hidden';
}, (0, _polished.transitions)('visibility .3s ease-in-out, opacity .3s ease-in-out'));

var Loader = function Loader(_ref3) {
  var visible = _ref3.visible;
  return _react2.default.createElement(Container, {
    visible: visible
  }, _react2.default.createElement(_Button2.default, {
    theme: 'black',
    size: 'large',
    loading: true
  }));
};

exports.default = Loader;